(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Pricing', Pricing);

    Pricing.$inject = ['$resource'];

    function Pricing ($resource) {
        var resourceUrl =  'api/pricings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
